import {Show, ShowProps} from 'platform/foundation';

export function ShowOnMobileNavigation(props: ShowProps) {
  return <Show onMobile onTablet {...props} />;
}
